<template>
  <div class="flex flex-wrap sm:flex-row">
    <div class="w-full sm:w-1/4 flex-row sm:flex-wrap flex">
      <div v-if="data[0]" class="w-1/2 sm:w-full ratio1_1 border-2 border-white bg-cover bg-center bg-no-repeat" :style="`background-image: url('${data[0].url}');`">

      </div>
      <div v-if="data[1]" class="w-1/2 sm:w-full ratio1_1 border-2 border-white bg-cover bg-center bg-no-repeat" :style="`background-image: url('${data[1].url}');`">

      </div>
    </div>
    <div v-if="data[2]" class="w-full sm:w-3/4 ratio2_1 border-2 border-white bg-cover bg-center bg-no-repeat" :style="`background-image: url('${data[2].url}');`">

    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: false
    }
  }
}
</script>